import { ReactNode } from "react";

type Props = {
  children: ReactNode;
};
export default function DetailCardWrapper({ children }: Props) {
  return <div className="relative grid grid-cols-6 gap-5 mt-5">{children}</div>;
}
